export default {
  sessions: [],
  answers: [],
  questions: [],
  isCanFinish: false,
  currentQuestion: null,
  session: null,
  errors: null
};
